import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CashBalanceTaskStatus } from 'src/app/dto';

@Component({
    selector: 'app-cash-balance-task',
    templateUrl: './cash-balance-task.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CashBalanceTaskComponent {
    @Input() task: CashBalanceTaskStatus;
}
